export default __webpack_public_path__ + "static/media/hht1_ep05_book_wp_02.ba3197b2.jpg";